/**
 * Returns true when a donor/mother screening status should block label printing.
 *
 * Per Suzanne Smith's guidance on SV-274 (2026-09-24): rejected, expired,
 * on-hold, and pending donors are all blocked -- only approved/cleared donors
 * may print. Case-insensitive and hyphen/underscore-insensitive so it works
 * both with the app-level lowercase status (`Mother.screeningStatus` /
 * `DonorListItem.status`, e.g. 'on-hold') and the raw uppercase API status
 * used by callers that haven't gone through the transform layer (e.g.
 * `PrintLabelsQuickActionModal.vue`'s `screening_status`, 'ON_HOLD').
 */
const PRINT_BLOCKED_STATUSES = new Set(['REJECTED', 'EXPIRED', 'ON_HOLD', 'PENDING']);

export function isDonorScreeningBlocked(status: string | null | undefined): boolean {
  if (!status) return false;
  return PRINT_BLOCKED_STATUSES.has(status.toUpperCase().replace(/-/g, '_'));
}
